import {Injectable} from '@angular/core';
import {CommonHttpService} from "../../../api/common-http.service";
import {Observable} from "rxjs/internal/Observable";
import {AppResponse} from "../../../api/app-response.model";
import {RegisterRequest} from "../../../model/register/register-request.model";

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(private http: CommonHttpService) {
  }

  register(data: RegisterRequest): Observable<AppResponse<void>> {
    return this.http.post<null>("/accounts/register", data);
  }
}
